import { ACCOUNT_STEPS } from "./utilities-config";

// Header shared by every card: a title and one rail per step. Finished steps are full, the active
// step fills to `progress`, later steps stay empty. On phones the rails collapse into one bar with "n of N".
export default function Card({
  progress = 0,
  title = "One time setup",
  onBack,
  footer = null,
  tall = false,
  wide = false,
  steps = ACCOUNT_STEPS,
  activeStep = 0,
  children,
}) {
  const overall = ((activeStep + progress / 100) / steps.length) * 100;
  return (
    <section className={`su-card${tall ? " su-card--tall" : ""}${wide ? " su-card--wide" : ""}`}>
      <div className="su-card-head">
        {onBack ? (
          <button className="su-back" type="button" aria-label="Go back" onClick={onBack}>
            <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
              <path d="M7.5 2.5L4 6l3.5 3.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        ) : null}
        <span className="su-card-title">{title}</span>
        <div className="su-steps">
          {steps.map((label, index) => {
            const fill = index < activeStep ? 100 : index === activeStep ? progress : 0;
            return (
              <div key={label} className={`su-step${index <= activeStep ? " is-active" : ""}`}>
                <div className="su-track">
                  <i style={{ width: `${fill}%` }} />
                </div>
                <span>{label}</span>
              </div>
            );
          })}
        </div>
        <div className="su-steps-mobile">
          <div className="su-track">
            <i style={{ width: `${overall}%` }} />
          </div>
          <div className="su-steps-mobile-labels">
            <strong>{steps[activeStep]}</strong>
            {steps.length > 1 ? (
              <span>
                {activeStep + 1} of {steps.length}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      <div className="su-card-body">{children}</div>
      {footer ? <div className="su-card-foot">{footer}</div> : null}
    </section>
  );
}
